import moment from "moment-jalaali";
import Vue from "vue";
import { getToken, logout } from "@/utils/auth";
import store from "@/store";
export const TODAY = moment().format("jYYYY/jMM/jDD");
export const LOADING = "در حال بارگذاری. لطفا چند لحظه صبر نمایید.";
export const NODATA = "داده ای برای نمایش وجود ندارد.";

export const mobile = Vue.observable({ mobile: {} });
Object.defineProperty(Vue.prototype, "$mobile", {
  get() {
    return mobile.mobile;
  },
  set(value) {
    mobile.mobile = value;
  },
});

export function widthChanged() {
  if (window.innerWidth < 992) {
    if (!Vue.prototype.$mobile) Vue.set(Vue.prototype, "$mobile", true);
  } else if (Vue.prototype.$mobile) Vue.set(Vue.prototype, "$mobile", false);
}
// export function monitorFocus() {
//   var lastActive = window.document.hasFocus(); // 'static' memory between function calls

//   setInterval(() => {
//     var isActive = window.document.hasFocus();
//     if (lastActive != isActive) {
//       var hasToken = store.getters.token != "" && getToken();
//       if (isActive && hasToken) {
//         store.dispatch("GetUserInfo");
//         store.dispatch("GetBranchNames");

//       }

//       lastActive = isActive; // store latest cookie
//     }
//   }, 1000);
// }

export function toArabicCharacter(string) {
  var obj = {
    ك: "ک",
    // 'دِ': 'د',
    // 'بِ': 'ب',
    // 'زِ': 'ز',
    // 'ذِ': 'ذ',
    // 'شِ': 'ش',
    // 'سِ': 'س',
    // 'ى': 'ی',
    ي: "ی",
    // '١': '۱',
    // '٢': '۲',
    // '٣': '۳',
    // '٤': '۴',
    // '٥': '۵',
    // '٦': '۶',
    // '٧': '۷',
    // '٨': '۸',
    // '٩': '۹',
    // '٠': '۰',
  };

  Object.keys(obj).forEach(function(key) {
    string = string.replaceAll(obj[key], key);
  });
  return string.toLowerCase();
}

//checkCookie()

window.addEventListener("resize", widthChanged);
//window.addEventListener("beforeunload", logout);

export function saveByteArray(data, fileName) {
  const elem = window.document.createElement("a");
  elem.href = window.URL.createObjectURL(data);
  elem.download = fileName;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);

  store.commit(
    "SET_SNACKBAR_TEXT",
    "دانلود با موفقیت به پایان رسید. شما می توانید از بخش دانلود ها فایل مورد نظر را مشاهده  فرمایید."
  );
}
